export const dataHooks = {
  StoreNameInput: 'store-name-input',
  StoreNameSuggestion: 'store-name-suggestion',
  StoreNameMainContent: 'store-name-main-content',
  StoreNameSideContent: 'store-name-side-content',
  MobileStoreName: 'mobile-store-name',
  acceptPaymentsWidget: 'accept-payments-widget',
  acceptPaymentsCheckbox: 'accept-payments-checkbox',
  skipPaymentsButton: 'skip-payments-button',
  acceptPaymentsButton: 'accept-payments-button',
  modalystTermsCheckbox: 'modalyst-terms-checkbox',
};
